module.exports = __webpack_public_path__ + "img/banner-technology-1.17fb8faf.png";